export enum scoutsApplicantsTypes {
  FETCH_SCOUTS_APPLICANTS_REQUEST = "FETCH_SCOUTS_APPLICANTS_REQUEST",
  FETCH_SCOUTS_APPLICANTS_SUCCESS = "FETCH_SCOUTS_APPLICANTS_SUCCESS",
  FETCH_SCOUTS_APPLICANTS_FAILURE = "FETCH_SCOUTS_APPLICANTS_FAILURE",
}